import { createAsyncThunk } from '@reduxjs/toolkit';
import { buildSalesforceParamsQuery } from '../../utils/methods';
import request from '../../modules/Request/request';

export const getEventTimeLine = createAsyncThunk(
  'getEventTimeLine',
  async (object, { rejectWithValue }) => {
    const { accountId } = object;
    const finalQuery = buildSalesforceParamsQuery({}, object);
    const response = await request('/license-timeline-data', { method: 'GET', query: finalQuery, params: [accountId] });
    if (response.success) return response.data;
    const error = response.error && response.error.message
      ? response.error.message
      : response.error;
    throw rejectWithValue(error || 'Something went wrong');
  },
);
